import { Modal, Flex } from 'antd'
import { FormattedMessage } from 'react-intl'
import { useMemo, useState } from 'react'
import { ICurrency } from '../../api/types'
import Search from '../SelectModal/Search'
import Option from '../SelectModal/Option'
import Header from '../SelectModal/Header'
import { makeFilterByCodeName } from '../SelectModal/makeFilterByCodeName'
import s from './s.module.css'
import { lang } from './lang'

export type Props = {
  isOpen: boolean
  onClose: () => void
  selectedOption: ICurrency | null
  onSelectOption: (value: ICurrency) => void
  options: ICurrency[]
}

export default function FiatModal({ isOpen, onClose, options, onSelectOption, selectedOption }: Props) {
  const [searchQuery, setSearchQuery] = useState('')
  const filteredOptions = useMemo(() => options.filter(makeFilterByCodeName(searchQuery)), [searchQuery, options])

  const handleSelect = (value: ICurrency) => {
    onSelectOption?.(value)
    setSearchQuery('')
    onClose()
  }

  return (
    <Modal open={isOpen} footer={false} onCancel={onClose} width={408}>
      <Flex vertical gap={16}>
        <Header
          title={<FormattedMessage {...lang.selectTitle} />}
          subtitle={<FormattedMessage {...lang.selectSubtitle} values={{ amount: options.length }} />}
        />
        <Search searchQuery={searchQuery} onChange={setSearchQuery} />
        <Flex vertical className={s.list}>
          {filteredOptions.map(option => (
            <Option
              key={option.code}
              {...option}
              icon={option.icon_url}
              isSelected={selectedOption?.code === option.code}
              onClick={() => handleSelect(option)}
            />
          ))}
        </Flex>
      </Flex>
    </Modal>
  )
}
